export default "__VITE_ASSET__5127723b__"